import { useEffect, useState } from "react";
import { findAllRemissionsOrderByDateEvent } from "../../_events/remission/find_remission.event";
import { message } from "antd";

export const useRemissionTabeOrderByDate = () => {

    const [ data, setData ] = useState([]);

    useEffect(() => {
        findAllRemissionsOrderByDateEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            message.error(err.message);
        })
    }, []);

    return {
        data
    };
}